var BaseClient = /** @class */ (function () {
    function BaseClient() {
    }
    // 发送事件统一入口
    BaseClient.prototype.sendEvent = function (event) {
        var _modifiedOptions = this.getEventToBeSent(event);
        if (_modifiedOptions) {
            this.idleSendEvent(_modifiedOptions);
        }
    };
    BaseClient.prototype.getEventToBeSent = function (event) {
        var _modifiedOptions = this._modifyEvent(event);
        if (!this._shouldSend(_modifiedOptions)) {
            return;
        }
        return _modifiedOptions;
    };
    // 修改 event 内容
    BaseClient.prototype._modifyEvent = function (event) {
        return event;
    };
    // event 是否发送
    BaseClient.prototype._shouldSend = function (_event) {
        return true;
    };
    // 需要实现的发送方法
    BaseClient.prototype._send = function (_event) {
        return;
    };
    // 主进程空闲时间发送
    BaseClient.prototype.idleSendEvent = function (event) {
        this._send(event);
    };
    return BaseClient;
}());
export { BaseClient };
//# sourceMappingURL=client.js.map